<template>
  <div>
    <Drawer
      v-model="editDrawerStatus"
      :title="'新增'"
      width="500"
      :transfer="true"
      class="DrawerStyle"
    >
      <div class="drawer-content" style="padding-bottom:50px;">
        <objectAddOrEdit
          v-if="editDrawerStatus"
          class="left"
          ref="objectAddOrEdit"
          :data="{isFlowType:params.flow_instance_id?'1':'0',tenantId:params.tenant_id,moId:params.moId,rowId:params.row_id,mtId:'',busType:params.busType,modelId:params.flow_model_id,isApprovePage:true}"
          @on-success="onEditSuccess"
        ></objectAddOrEdit>
      </div>

      <div class="cmsc-drawer-footer">
        <template v-if="!params.flow_instance_id">
          <Button class="handle-item" @click="editCancel">取消</Button>
          <Button class="handle-item" type="primary" @click="editSubmit">保存</Button>
        </template>
        <template v-else>
          <Button class="handle-item" @click="editCancel">取消</Button>
          <Button class="handle-item" type="primary" @click="editSubmit({state: '1'})">暂存</Button>
          <Button class="handle-item" type="primary" @click="editSubmit({state: '2'})">提交</Button>
        </template>
      </div>
    </Drawer>
    <Modal v-model="nextUserModel" title="请选择下一处理节点信息">
      <PacketSelector
        style="width: 350px"
        :options="nextAssignList"
        v-model="nextUserValue"
        ref="packetSelectorInput"
      ></PacketSelector>
      <div slot="footer">
        <Button size="large" @click="nextUserModel=false">取消</Button>
        <Button size="large" @click="nextUserSure">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import envConst from '@/env-const.js'
export default {
  data() {
    return {
      editDrawerStatus: false,
      nextUserModel: false,
      nextAssignList: [],
      nextUserValue: [],
      flowState: '',
      ApproveTaskDate: {
        addApproveTaskDate: {
          nextUserId: '',
          processDefinitionId: '',
          outgoingId: '',
          currnetUserId: '',
          approveOpinion: '',
          currentTaskId: '',
          processInstanceId: '',
          nextGroup: '',
          taskDefinitionKey: '',
          formData: {}
        },
        customFieldDate: [],
        taskState: '',
        transmitUserId: '',
        moId: '',
        modelId: '',
      },
      opinions: [
        {
          id: 'department',
          label: h => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-apps'
                }
              }),
              h('span', '部门')
            ])
          },
          list: [],
          type: 'tree'
        },
        {
          id: 'role',
          label: h => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-people'
                }
              }),
              h('span', '角色')
            ])
          },
          type: 'checkbox',
          list: []
        },
        {
          id: 'user',
          label: h => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-person'
                }
              }),
              h('span', '用户')
            ])
          },
          type: 'checkbox',
          list: []
        }
      ]
    }
  },
  props: {
    params: Object,
    isSccm: Boolean
  },
  created() {
    this.getUserInfoFromSession()
  },
  methods: {
    /**
     * 从session获取登陆人信息
     */
    getUserInfoFromSession: function() {
      let userInfo = JSON.parse(window.localStorage.user)
      this.loginUserInfo = userInfo.info
    },
    openDrawer() {
      console.log(this.params)
      this.editDrawerStatus = true
    },
    // 编辑器提交
    editSubmit(params) {
      // this.ApproveTaskDate.addApproveTaskDate.processInstanceId = this.params.flow_instance_id
      this.ApproveTaskDate.addApproveTaskDate.processDefinitionId = this.params.flow_model_id
      this.ApproveTaskDate.moId = this.params.moId
      this.ApproveTaskDate.modelId = this.params.flow_model_id
      let state = '1'
      if (params.state == 1) {
        state = '1'
        this.editSubmitData(state)
      } else if (params.state == undefined) {
        state = ''
        this.editSubmitData(state)
      } else {
        state = '2'
        /*var customFiled = this.$refs['objectAddOrEdit'].getFormData(
          'customFormData'
        )*/
		  this.$refs['objectAddOrEdit'].getFormData('customFormData').then(customFiled=> {
			  console.log('111', customFiled)
              if (customFiled.returnCode === '0') {
                  this.ApproveTaskDate.addApproveTaskDate.formData = customFiled.values
                  this.getNextAssignUser(state)
              }
          });
      }
    },
    editSubmitData(state){
		this.$refs['objectAddOrEdit'].getFormData('customFormData').then(customFiled=> {
			console.log('111', customFiled)
            this.editSubmitDataSure(state,customFiled)
        });
    },
    editSubmitDataSure(state,customFiled) {
      /*var customFiled = this.$refs['objectAddOrEdit'].getFormData(
        'customFormData'
      )*/
      if (customFiled.returnCode === '0') {
        var columnObj = customFiled.values
        let approveTaskData = {}
        approveTaskData.nextGroup =
          this.ApproveTaskDate.addApproveTaskDate.nextGroup == undefined
            ? ''
            : this.ApproveTaskDate.addApproveTaskDate.nextGroup
        approveTaskData.approveOpinion = customFiled.approveOpinion
        approveTaskData.formData = columnObj
        approveTaskData.currentTaskId =
          this.ApproveTaskDate.addApproveTaskDate.currentTaskId == undefined
            ? ''
            : this.ApproveTaskDate.addApproveTaskDate.currentTaskId
        approveTaskData.outgoingId =
          this.ApproveTaskDate.addApproveTaskDate.outgoingId == undefined
            ? ''
            : this.ApproveTaskDate.addApproveTaskDate.outgoingId
        approveTaskData.processInstanceId = ''
        columnObj['tenant_id'] = this.loginUserInfo.tenantId
        columnObj['business_type'] = this.params.busType
        columnObj['create_by'] = this.loginUserInfo.userId
        if (!this.isSccm) {
          columnObj['state'] = state
        }
        if (this.method == 'update') {
          columnObj['whereOf'] = { mt_id: this.currentBusiness.mtId }
        }
        let objval = {}
        console.log(this.isSccm)
        for (let i in columnObj) {
          if (!this.isSccm || i != 'state') {
            objval[i] = columnObj[i]
          }
        }
        var params = {}
        if (this.isSccm) {
          var params = {
            Head: {
              moId: this.params.moId,
              method: 'insert',
              version: 'v1.0'
            },
            Data: [
              {
                // mtId: this.params.mtId,
                moId: this.params.moId,
                OBJECT_NAME: customFiled.OBJECT_NAME,
                modelId: this.params.flow_model_id,
                approveTaskDate: approveTaskData,
                value: objval
              }
            ]
          }
        } else {
          params = {
            Head: {
              moId: this.params.moId,
              method: 'insert',
              version: 'v1.0'
            },
            Data: [
              {
                // mtId: this.params.mtId,
                state: state,
                moId: this.params.moId,
                OBJECT_NAME: customFiled.OBJECT_NAME,
                modelId: this.params.flow_model_id,
                approveTaskDate: approveTaskData,
                value: objval
              }
            ]
          }
        }

        this.$http
          .post(
            `${envConst.API_BASE_URL}/scmd/dynObject/operObjectCheck`,
            params
          )
          .then(response => {
            if (response.data.returnCode == 0) {
              if (!response.data.bean.checkCode) {
                this.$Message.error(response.data.bean.errMsg)
              } else {
                this.$Message.success('保存成功')
                this.onEditSuccess()
              }
            } else {
              this.$Message.error('保存失败')
            }
          })
      }
    },
    nextUserSure() {
      this.flowState = this.params.state_id || ''
      if (this.nextUserValue.length == 0) {
        this.$Message.warning('请选择要下一节点信息')
        return false
      } else if (this.nextUserValue.length > 1) {
        this.$Message.warning('部门、角色、用户只能选择一个')
        return false
      }
      this.ApproveTaskDate.addApproveTaskDate.nextGroup = this.nextUserValue[0]
      this.nextUserModel = false
      if (this.flowState == '' || this.flowState == '1') {
        this.editSubmitData('2')
      } else {
        this.editSubmitData('2')
        // this.approveTask()
      }
    },
    /**
     * 提交流程
     */
    approveTask() {
      let _this = this
      _this.$http
        .post(
          `${envConst.API_BASE_URL}/scmd/flow/approveWorkFlow`,
          _this.ApproveTaskDate
        )
        .then(function(data) {
          if (data.data.returnCode == 0) {
            // 获取需要渲染到页面中的数据
            _this.$Message.success(_this.handleName + '成功')
            // _this.onHandleSuccess()
          } else {
            _this.$Message.error(data.data.returnMessage)
          }
        })
    },
    onEditSuccess() {
      this.editCancel()
    },
    editCancel() {
      this.editDrawerStatus = false
      this.ApproveTaskDate = {
        addApproveTaskDate: {
          nextUserId: '',
          processDefinitionId: '',
          outgoingId: '',
          currnetUserId: '',
          approveOpinion: '',
          currentTaskId: '',
          processInstanceId: '',
          nextGroup: '',
          taskDefinitionKey: '',
          formData: {}
        }
      }
    },
    getNextAssignUser(state) {
      let item = { id: this.nextUserValue[0] }
      if (this.nextUserValue.length > 0) {
        this.$refs['packetSelectorInput'].deleteSelectedItem(item)
      }
      this.ApproveTaskDate.addApproveTaskDate.formData.tenant_id = this.loginUserInfo.tenantId
      this.ApproveTaskDate.addApproveTaskDate.formData.business_type = this.params.busType
      this.ApproveTaskDate.addApproveTaskDate.formData.state = '2'
      this.$http
        .post(
          envConst.API_BASE_URL + '/scmd/flow/getNextTask',
          this.ApproveTaskDate.addApproveTaskDate
        )
        .then(response => {
          if (response.data.returnCode == 0) {
            //结束节点
            if (response.data.bean.endNode) {
              this.ApproveTaskDate.taskState =
                mConst.workOrder.state.WORK_ORDER_END
            }

            if (
              response.data.bean.userRoleOrgMap &&
              response.data.bean.outgoingId
            ) {
              this.ApproveTaskDate.addApproveTaskDate.outgoingId =
                response.data.bean.outgoingId
              this.nextAssignUser = response.data.bean.userRoleOrgMap.userList
              this.nextAssignOrg = response.data.bean.userRoleOrgMap.orgList
              this.nextAssignRole = response.data.bean.userRoleOrgMap.roleList
              let userList = response.data.bean.userRoleOrgMap.userList
              let orgList = response.data.bean.userRoleOrgMap.orgList
              let roleList = response.data.bean.userRoleOrgMap.roleList

              if (
                this.nextAssignUser.length == 1 &&
                this.nextAssignOrg.length == 0 &&
                this.nextAssignRole.length == 0
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'user_' + this.nextAssignUser[0].userId
                if (state != undefined) {
                  this.editSubmitData(state)
                } else {
                  this.approveTask()
                }
              } else if (
                this.nextAssignUser.length == 0 &&
                this.nextAssignOrg.length == 1 &&
                this.nextAssignRole.length == 0
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'dept_' + this.nextAssignOrg[0].orgId
                if (state != undefined) {
                  this.editSubmitData(state)
                } else {
                  this.approveTask()
                }
              } else if (
                this.nextAssignUser.length == 0 &&
                this.nextAssignOrg.length == 0 &&
                this.nextAssignRole.length == 1
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'role_' + this.nextAssignRole[0].roleId
                if (state != undefined) {
                  this.editSubmitData(state)
                } else {
                  this.approveTask()
                }
              } else {
                let options = this.opinions
                options[0].list = []
                options[1].list = []
                options[2].list = []
                const transformTree = (beans, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      let obj = {
                        id: `dept_${item.orgId}`,
                        title: item.title,
                        isEdit: item.isEdit,
                        children: []
                      }
                      if (item.children.length > 0)
                        transformTree(item.children, obj.children)

                      list.push(obj)
                    })
                  }
                }
                const transformCheckbox = (beans, type, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      list.push({
                        id: `${type}_${item[`${type}Id`]}`,
                        title: item[`${type}Name`]
                      })
                    })
                  }
                }
                const transformCheckboxDept = (beans, type, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      list.push({
                        id: `${type}_${item[`orgId`]}`,
                        title: item[`orgName`]
                      })
                    })
                  }
                }
                if (response.data.bean.assignAllUsers || true) {
                  transformTree(orgList, options[0].list)
                  transformCheckbox(roleList, 'role', options[1].list)
                  transformCheckbox(userList, 'user', options[2].list)
                } else {
                  transformCheckboxDept(orgList, 'dept', options[0].list)
                  transformCheckbox(roleList, 'role', options[1].list)
                  transformCheckbox(userList, 'user', options[2].list)
                }
                options[0].type = "tree"
                // options[0].type = response.data.bean.assignAllUsers
                //   ? 'tree'
                //   : 'checkbox'
                this.nextAssignList = options
                this.nextUserModel = true
              }
            } else {
              this.ApproveTaskDate.addApproveTaskDate.outgoingId = ''
              if (state != undefined) {
                this.editSubmitData(state)
              } else {
                this.approveTask()
              }
            }
          } else {
            this.spinShow = false
            this.$Message.error('获取下一节点信息失败')
          }
        })
        .catch(function(error) {
          console.log('获取下一节点信息异常', error)
          this.$Message.error('流程处理失败，请刷新列表重试')
        })
    }
  }
}
</script>

<style scoped lang="less" >
.DrawerStyle {
  .ivu-drawer-body {
    position: static;
    height: calc(100% - 95px);
    .cmsc-drawer-footer {
      background: #fff;
      position: fixed;
      width: 500px;
      right: 0;
      left: inherit;
      bottom: 0;
    }
  }
}
</style>